/**
 * IndexedDB backup of full telemetry for large runs synced to Firestore + Storage.
 * Used when the remote JSON file is missing or corrupt so RideView can still open the run on this device.
 */

import localforage from 'localforage';

const snapshotStore = localforage.createInstance({
  name: 'shokiq-pwa',
  storeName: 'runTelemetrySnapshots',
});

function cacheKey(userId, runId) {
  return `${userId}::${runId}`;
}

export async function saveRunTelemetrySnapshot(userId, runId, telemetryData) {
  if (!userId || !runId || !Array.isArray(telemetryData) || telemetryData.length === 0) return;
  await snapshotStore.setItem(cacheKey(userId, runId), telemetryData);
}

export async function loadRunTelemetrySnapshot(userId, runId) {
  if (!userId || !runId) return null;
  try {
    const v = await snapshotStore.getItem(cacheKey(userId, runId));
    return Array.isArray(v) && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

export async function removeRunTelemetrySnapshot(userId, runId) {
  if (!userId || !runId) return;
  try {
    await snapshotStore.removeItem(cacheKey(userId, runId));
  } catch {
    // ignore
  }
}
